import { useAuthenticator } from "@aws-amplify/ui-react";
import NotificationPage from "components/NotificationPage";
import { getCognitoUserAttribute } from "helpers/utils";
import { useEffect } from "react";
import { getAllNotifications } from "store/notificationStore";
import { useAppDispatch, useAppSelector } from "store/store";

const Notifications = () => {
    const { allNotifications } = useAppSelector((state) => state.notification);
    const { user } = useAuthenticator((context) => [context.user]);
    const userAttributes = getCognitoUserAttribute("custom:accountType", user);
    const dispatch = useAppDispatch();
    const baseURL =
        userAttributes === "beneficiary"
            ? import.meta.env.REACT_APP_API_BENEFICIAR_PORTAL_ENDPOINT
            : ["publisher", "admin"].includes(userAttributes)
              ? import.meta.env.REACT_APP_API_ENDPOINT
              : "";

    useEffect(() => {
        if (baseURL) dispatch(getAllNotifications(baseURL));
    }, [baseURL]);

    return <NotificationPage notifications={allNotifications} />;
};

export default Notifications;
